import { createApp } from 'vue'
import App from './App.vue'
import router from './router';
import store from "./store"; //Added 2022-11-27 (https://www.bezkoder.com/vue-3-authentication-jwt/)
import { IonicVue } from '@ionic/vue';

/* Core CSS required for Ionic components to work properly */
import '@ionic/vue/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/vue/css/normalize.css';
import '@ionic/vue/css/structure.css';
import '@ionic/vue/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/vue/css/padding.css';
import '@ionic/vue/css/float-elements.css';
import '@ionic/vue/css/text-alignment.css';
import '@ionic/vue/css/text-transformation.css';
import '@ionic/vue/css/flex-utils.css';
import '@ionic/vue/css/display.css';

/* Theme variables */
import './theme/variables.css';

import MasterLayout from './components/MasterLayout.vue'; //Added 2022-11-23
import i18n from './i18n.js';
//import axios from 'axios'; // Added for Axios 2024-04-04 for reroute axios interception Removed when replaced by bezkoder code
import setupInterceptors from './services/setupInterceptors.js';
import "./assets/folkwiki.css";
//import Raters from 'vue-rate-it';//Added 2022-12-01

if (process.env.NODE_ENV === 'production') {
  console.log = () => {};
}

setupInterceptors(store);

const app = createApp(App)
  .use(IonicVue)
  .use(router)
  .use(store)//Added 2022-11-27
  .use(i18n);//Added 2022-11-28

app.component('master-layout',MasterLayout); //Added 2022-11-23
  
router.isReady().then(() => {
  app.mount('#app');
});